import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from './img/关闭.svg';
const _withScopeId = n => (_pushScopeId("data-v-362d820d"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "my_dialog"
};
const _hoisted_2 = {
  class: "my_header"
};
const _hoisted_3 = ["id"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_6 = [_hoisted_5];
const _hoisted_7 = {
  class: "form_wrap"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "consultation"
}, "咨询电话：18122752759", -1));
import { ref } from 'vue';
import { useForm } from '@/hooks/useForm';
export default {
  __name: 'index',
  setup(__props, {
    expose
  }) {
    const {
      ruleFormRef,
      orgTypeList,
      formData,
      rules,
      btnText,
      btnDisabled,
      handleSendCode,
      handleSubmit
    } = useForm();
    const visible = ref(false);
    const openForm = async function (defaultData = {}) {
      visible.value = true;

      // 设置默认值
      if (defaultData.orgtype) {
        formData.value.orgtype = defaultData.orgtype;
      }
    };
    const hideForm = function () {
      visible.value = false;
    };
    const handleSubmitBtn = function () {
      handleSubmit().then(res => {
        if (res.errorCode == 0) {
          hideForm();
        }
      });
    };
    expose({
      //暴露函数给父组件调用
      openForm,
      hideForm
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => visible.value = $event),
        "show-close": false,
        width: "800px",
        "align-center": "",
        "destroy-on-close": ""
      }, {
        header: _withCtx(({
          close,
          titleId,
          titleClass
        }) => [_createElementVNode("div", _hoisted_2, [_createElementVNode("h4", {
          id: titleId,
          class: _normalizeClass(titleClass)
        }, "免费申请试用", 10, _hoisted_3), _createElementVNode("div", {
          class: "img_wrap",
          onClick: close
        }, _hoisted_6, 8, _hoisted_4)])]),
        footer: _withCtx(() => [_createElementVNode("span", {
          class: "dialog_footer"
        }, [_createElementVNode("div", {
          class: "submit",
          onClick: handleSubmitBtn
        }, "提交申请"), _hoisted_8])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_form, {
          ref_key: "ruleFormRef",
          ref: ruleFormRef,
          model: _unref(formData),
          rules: _unref(rules),
          "label-position": 'left',
          "label-width": "120px",
          size: 'large'
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "姓名",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).name = $event),
              placeholder: "请填入姓名"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "机构名称",
            prop: "orgname"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).orgname,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(formData).orgname = $event),
              placeholder: "请填入机构名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "机构类型",
            prop: "orgtype"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: _unref(formData).orgtype,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(formData).orgtype = $event),
              placeholder: "请选择机构类型"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orgTypeList), item => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: item.value,
                  label: item.label,
                  value: item.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "手机号",
            prop: "phone"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).phone,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(formData).phone = $event),
              placeholder: "请填写手机号码"
            }, {
              prepend: _withCtx(() => [_createTextVNode("+86")]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "验证码",
            prop: "captcha"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(formData).captcha,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(formData).captcha = $event),
              placeholder: "请输入验证码"
            }, {
              append: _withCtx(() => [_createVNode(_component_el_button, {
                class: "sendCode",
                onClick: _unref(handleSendCode),
                disabled: _unref(btnDisabled)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(btnText)), 1)]),
                _: 1
              }, 8, ["onClick", "disabled"])]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};